<div class="loaders-spinner -size-{{size || 'dynamic'}}"
    [ngClass]="{'-inverted': inverted, '-brand-accent': brandAccent}">
    <svg class="loaders-spinner__svg" viewBox="0 0 50 50">
        <circle [ngStyle]="{'stroke': !brandAccent && color, 'stroke-width': thickness}" class="loaders-spinner__path"
            cx="25" cy="25" r="20" fill="none">
        </circle>
    </svg>
</div>
